import {common} from "../../../global/common.js";
import _ from 'lodash';
import {singleRequest} from "../../../global/singleRequest.js";
import {mapGetters} from "vuex";
import {planPricesMixin} from "./planPricesMixin.js";
import {planCategoryFilterMixin} from "./planCategoryFilterMixin.js";

export const baseResultMixin = {
	props: {baseData: {type: [Object], required: true}, additionalData: {type: [Object], required: true}},
	mixins: [planPricesMixin, planCategoryFilterMixin],
	data() {
		return {
			coordinatesClass: 'coordinate-' + ((this.baseData.latitude + '' + this.baseData.longitude).replace(/\D/g, '')),
			errorMessage: "",
			standardPlan: {},
			vm: {},
			profilePicture: '',
			notes: '',
			widgetReady: false,
			showFeeDisclaimer: false,
			feeDisclaimerText: "Please note: The fees displayed below do not reflect any contributions, discounts, or other payments that might be made by your group or employer on your behalf."
		}
	},
	computed: {
		...mapGetters({showInOfficePlans: 'globalSettings/showInOfficePlans', showVirtualPlans: 'globalSettings/showVirtualPlans'}),
	},
	methods: {
		viewProfile() {
			throw new Error('ViewProfile methods needs to be overwritten by child');
		},
		viewInMap() {
			this.$bus.$emit(this.$AcEvents.LOCATE_IN_MAP, this.baseData);
		},
		toggleFeeDisclaimer() {
			this.showFeeDisclaimer = !this.showFeeDisclaimer;
		},
		hideFeeDisclaimer() {
			this.showFeeDisclaimer = false;
		},
		async baseInit(detailsUrl) {
			try {
				//console.log("Loading details, url:", detailsUrl, " distance: ", this.distance);
				let fullDetails = await singleRequest.getRequest(detailsUrl, () => {
					return $.ajax({type: "GET", global: false, url: detailsUrl});
				}, true);
				//console.log("FullDetails: ", {fullDetails: fullDetails})
				this.mapData('vm', fullDetails);
				this.vm.plansCost = this.filterPlansByCategory(this.vm.plansCost || []);
				let self = this;
				this.vm.prices = self.getPrices(this.vm.plansCost);
				this.setMaxAndMinAge();
				this.vm.designation = common.filterProfDesignations(this.vm.designation);
				this.errorMessage = '';
				this.profilePicture = common.generateImageLink(fullDetails.profilePictureId, common.IMAGE_SIZE.MEDIUM.id);
				if (fullDetails.plansCost && fullDetails.plansCost.length > 0) {
					let cheapestPlan = _.minBy(fullDetails.plansCost, 'adultFee');
					this.standardPlan = cheapestPlan;
					this.notes = cheapestPlan.otherServices;
				}
			} catch (err) {
				console.log("search result error:", err);
				this.errorMessage = `Error loading data for Dr ${this.baseData.name}, error: ${err.responseText}`;
			}
			this.widgetReady = true;
		},
		locateInMap() {
			this.$bus.$emit(this.$AcEvents.HIGHLIGHT_COORDINATES_IN_LIST, {latitude: this.baseData.latitude, longitude: this.baseData.longitude});
			this.$bus.$emit(this.$AcEvents.LOCATE_IN_MAP, {latitude: this.baseData.latitude, longitude: this.baseData.longitude});
		},
		setMaxAndMinAge(){
			if (!this.vm.plansCost || this.vm.plansCost.length === 0) {
				return;
			}
			let maxAge = this.vm.plansCost[0].maxAge;
			let minAge = this.vm.plansCost[0].minAge;

			this.vm.plansCost.forEach(plan =>{
				maxAge = Math.max(maxAge, plan.maxAge);
				minAge = Math.min(minAge, plan.minAge);
			})
			this.vm.maxAge = maxAge;
			this.vm.minAge = minAge;			
		}
	}
};